'use strict';

/**
 * Инит магнифика, тип iframe
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#iframe-type}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

import Preloader from '../Preloader';

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {string} [selector=".js-mfp-iframe"]- поиск элементов по селектору
 * @param {jQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init (selector, $context, userConfig) {
	let $elements = (selector && selector.jquery) ? selector : $(selector, $context);
	$elements.each((i, el) => {
		let $element = $(el);
		let config = $.extend(true, {
			type: 'iframe',
			closeBtnInside: true,
			removalDelay: 300,
			mainClass: 'mfp-animate-zoom-in'
		}, userConfig);

		$element.magnificPopup(config);
	});
}

let myConfig = {
	closeMarkup: '<button class="mfp-close" id="custom-close-btn--video"></button>',

	iframe: {
		markup: '<div class="mfp-iframe-scaler">' +
		'<button class="mfp-close" id="custom-close-btn--video"></button>' +
		'<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
		'<div class="mfp-title"></div>' +
		'</div>',
		patterns: {
			youtube: {
				index: 'youtube.com/',
				id: 'v=',
				src: '//www.youtube.com/embed/%id%?autoplay=1'
			}
		},
		srcAction: 'iframe_src'
	}
};

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {string} [selector=".js-mfp-iframe"]- поиск элементов по селектору
 * @param {jQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpIframe (selector = '.js-mfp-iframe', $context = $('body'), userConfig = {}) {
	function load (event) {
		event.preventDefault();
		$context.off('click', selector, load);

		let $element = $(this);
		let preloader = new Preloader($element);
		preloader.show();

		import(
			/* webpackChunkName: "magnific-popup" */
			'./mfp'
		).then(() => {
			init(selector, $context, myConfig);
			preloader.hide();
			$element.magnificPopup('open');
		});
	}

	$context.on('click', selector, load);
}

// ----------------------------------------
// Exports
// ----------------------------------------

export default mfpIframe;



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/mfp/mfp-iframe.js